import { motion } from "framer-motion";

export default function TermsPrivacy({ type = "terms" }) {
  const isPrivacy = type === "privacy";

  return (
    <div className="min-h-screen bg-[#F8FAFC] font-sans">
      {/* ================= HERO SECTION ================= */}
      <section className="relative overflow-hidden bg-gradient-to-br from-[#0F2A44] via-[#1E88E5] to-[#0F2A44] text-white">
        
        {/* Animated SVG Circles */}
        <svg
          className="absolute top-0 left-0 w-full h-full opacity-20"
          viewBox="0 0 800 400"
          preserveAspectRatio="none"
        >
          <motion.circle
            cx="150"
            cy="120"
            r="90"
            fill="#F4B400"
            initial={{ scale: 0.6 }}
            animate={{ scale: 1 }}
            transition={{ duration: 3, repeat: Infinity, repeatType: "mirror" }}
          />
          <motion.circle
            cx="650"
            cy="80"
            r="70"
            fill="#ffffff"
            initial={{ opacity: 0.3 }}
            animate={{ opacity: 0.6 }}
            transition={{ duration: 4, repeat: Infinity, repeatType: "mirror" }}
          />
        </svg>

        <div className="relative max-w-6xl mx-auto px-6 py-28 text-center">
          {/* Logo */}
          <motion.img
            src="/img/logo.png"
            alt="University of Creative Technology Chittagong"
            className="h-16 mx-auto mb-6"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          />

          {/* Title */}
          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-4xl md:text-5xl font-bold mb-4"
          >
            {isPrivacy ? "Privacy Policy" : "Terms & Conditions"}
          </motion.h1>

          {/* Subtitle */}
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3 }}
            className="text-lg text-blue-100 max-w-3xl mx-auto"
          >
            University of Creative Technology Chittagong is committed to
            academic integrity, transparency, and protection of personal
            information.
          </motion.p>
        </div>

        {/* Bottom SVG Wave */}
        <svg
          className="absolute bottom-0 left-0 w-full"
          viewBox="0 0 1440 140"
          fill="none"
        >
          <path
            fill="#B7EAFC"
            d="M0,96L60,85.3C120,75,240,53,360,64C480,75,600,117,720,117.3C840,117,960,75,1080,64C1200,53,1320,75,1380,85.3L1440,96L1440,0L0,0Z"
          />
        </svg>
      </section>

      {/* ================= CONTENT SECTION ================= */}
      <section className="max-w-5xl mx-auto px-6 py-20">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="bg-white rounded-2xl shadow-xl border-t-4 border-[#F4B400] p-8 md:p-12"
        >
          <h2 className="text-2xl font-semibold text-[#0F2A44] mb-6">
            {isPrivacy ? "Data Protection & Usage" : "Institutional Terms of Use"}
          </h2>

          <p className="text-gray-700 leading-relaxed mb-5">
            {isPrivacy
              ? "The University of Creative Technology Chittagong collects personal information solely for academic, administrative, and communication purposes. All data is handled securely and in accordance with institutional and legal standards."
              : "By accessing UCTC digital platforms, students, faculty, and visitors agree to comply with all university policies, academic regulations, and applicable laws."}
          </p>

          <p className="text-gray-700 leading-relaxed mb-5">
            {isPrivacy
              ? "Personal information is never sold or shared with third parties unless legally required or authorized by the university administration."
              : "Unauthorized access, misuse of digital resources, or violation of academic integrity may result in disciplinary action."}
          </p>

          <p className="text-gray-700 leading-relaxed mb-5">
            {isPrivacy
              ? "Cookies may be used to enhance user experience and improve website functionality. Users may manage cookie preferences via browser settings."
              : "UCTC reserves the right to modify these terms at any time. Continued use of university services implies acceptance of updated policies."}
          </p>

          {/* Divider */}
          <div className="my-8 flex items-center gap-3">
            <span className="h-px flex-1 bg-gray-200"></span>
            <span className="text-sm text-gray-400">UCTC</span>
            <span className="h-px flex-1 bg-gray-200"></span>
          </div>

          <p className="text-sm text-gray-500 text-center">
            Last Updated: {new Date().toLocaleDateString()}
          </p>
        </motion.div>
      </section>
    </div>
  );
}
